import React from 'react';
import {Button, Icon} from 'antd';
import { isEqual, isEmpty, cloneDeep } from 'lodash';
import {WeaTools, WeaSearchGroup, WeaFormItem, WeaTable} from 'ecCom';
import {WeaLocaleProvider, WeaInputLocale} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import SynergySetting4Designer from '../synergy/SynergySetting4Designer';
import SynergySetting4WfVersions from '../synergy/SynergySetting4WfVersions';

import Content_1_DataSource from '../Content_1_DataSource';
import Content_7_DataSource from '../Content_7_DataSource';
import Content_8_DataSource from '../Content_8_DataSource';
import Content_29_DataSource from '../Content_29_DataSource';
import Content_reportForm_DataSource from '../Content_reportForm_DataSource';
import Content_OutData_DataSource from '../Content_OutData_DataSource';
import Content_13_DataSource from '../Content_13_DataSource';
import Content_10_DataSource from '../Content_10_DataSource';
import Content_news_DataSource from '../Content_news_DataSource';

class DataSourceTable extends React.Component {
    state = {
        tabNew: this.props.tabNew,
        tabCount: this.props.tabCount,
        tabIds: this.props.tabIds,
        tabList: this.props.tabList,
        dsVisible: false,
        tabData: {},
        selectedTabIds: []
    };

    constructor(props) {
        super(props);
        this.onAddTab = this.onAddTab.bind(this);
        this.onEditTab = this.onEditTab.bind(this);
        this.onSortTab = this.onSortTab.bind(this);
        this.onDeleteTab = this.onDeleteTab.bind(this);
        this.onDeleteTabs = this.onDeleteTabs.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.getSaveValues = this.getSaveValues.bind(this);
    }

    render() {
        const {hpid, eid, ebaseid, synergyParams = {}} = this.props;
        const {stype} = synergyParams;
        const {tabNew, tabData, tabList, dsVisible, selectedTabIds} = this.state;
        let dataSourceComponent = <div></div>;
        if (dsVisible) {
            const props = {
                eid: eid,
                tabNew: tabNew,
                tabData: tabData,
                onOk: this.onOk,
                onCancel: this.onCancel
            };

            switch (this.props.ebaseid) {
                // RSS阅读器
                case '1':
                    dataSourceComponent = <Content_1_DataSource {...props} />;
                    break;
                // 文档中心
                case '7':
                    dataSourceComponent = <Content_7_DataSource {...props} />;
                    break;
                // 流程中心
                case '8':
                    dataSourceComponent = <Content_8_DataSource {...props} />;
                    break;
                //我的协作
                case '13':
                    dataSourceComponent = <Content_13_DataSource {...props} />;
                    break;
                // 自定义页面
                case '29':
                    dataSourceComponent = <Content_29_DataSource {...props}/>;
                    break;
                // 图表
                case 'reportForm':
                    dataSourceComponent = <Content_reportForm_DataSource {...props} synergyParams={synergyParams}/>;
                    break;
                // 外部数据元素
                case 'OutData':
                    dataSourceComponent = <Content_OutData_DataSource {...props} />;
                    break;
                // 我的项目元素
                case '10':
                    dataSourceComponent = <Content_10_DataSource {...props} />;
                    break;
                // 公司新闻元素
                case 'news':
                    dataSourceComponent = <Content_news_DataSource {...props} />;
                    break;
                default:
                    dataSourceComponent = <div></div>;
            }
        }

        // 记录选中的行
        const _self = this;
        const rowSelection = {
            onChange(selectedRowKeys) {
                _self.setState({selectedTabIds: selectedRowKeys})
            }
        };

        const columns = [{
            key: 'tabTitle',
            title: getLabel(24986, '标题'),
            dataIndex: 'tabTitle',
            width: '50%'
        }, {
            key: 'operation',
            title: getLabel(30585, '操作'),
            width: '50%',
            render: (text, record) => (
                <span>
                    <span className="portal-esetting-dst-button" onClick={() => this.onEditTab(record.tabId)}>{getLabel(30747, '设置')}</span>
                    <span className="portal-esetting-dst-button" onClick={() => this.onAddTab('saveas',record.tabId)}>{getLabel(350, '另存为')}</span>
                    {hpid < 0 && ebaseid == '8' && (stype == 'wf' || stype == 'wf_form') ? <span className="synergy-setting-btn" onClick={() => this.ss4wv.onShow({...synergyParams, hpid, ebaseid, eid, tabid: record.tabId, isGlobal: false})}>{getLabel(17632, '参数设置')}</span> : ''}
                </span>
            )
        }];

        return (
            <WeaSearchGroup title={getLabel(20885, '内容来源')} needTigger={true} showGroup={true} customComponent={
                <div>
                    {hpid < 0 && (ebaseid == '8' || ebaseid == '7') ? <span className="synergy-setting-btn" onClick={() => this.ss4d.onShow({...synergyParams, hpid, ebaseid, eid, isGlobal: true})}>{getLabel(17632, '参数设置')}</span> : ''}
                    <Button type="primary" className="portal-esetting-wsg-btn" onClick={()=>this.onAddTab('add')}>
                        <Icon type="plus" style={{color: '#fff'}}/>
                    </Button>
                    <Button type="primary" disabled={!(selectedTabIds && selectedTabIds.length)} className="portal-esetting-wsg-btn" onClick={this.onDeleteTabs}>
                        <Icon type="minus" style={{color: '#fff'}}/>
                    </Button>
                    {/*<Button type="primary" onClick={() => sids.onDel()} disabled={!(selectedRowKeys && selectedRowKeys.length)}>批量删除</Button>*/}
                </div>
            }>
                {dataSourceComponent}
                <SynergySetting4Designer ref={(ss4d) => this.ss4d = ss4d}/>
                <SynergySetting4WfVersions ref={(ss4wv) => this.ss4wv = ss4wv}/>
                <WeaTable rowSelection={rowSelection} columns={columns} dataSource={tabList} pagination={false} draggable={true} onDrop={this.onSortTab}/>
            </WeaSearchGroup>
        );
    }

    onAddTab(type,tabId) {
        if('saveas' == type){
            let tabData = {};
            const {tabList} = this.state;
            for (let i = 0; i < tabList.length; i++) {
                if (tabList[i].tabId == tabId) {
                    tabData =cloneDeep( tabList[i].data);
                    break;
                }
            }
            tabData.id = '';
            this.setState({
                tabData: tabData,
                dsVisible: true
            });
        }else{
            this.setState({
                tabData: {},
                dsVisible: true
            });
        }

    }

    onDeleteTabs() {
        const {selectedTabIds} = this.state;
        for (let i = 0, len = selectedTabIds.length; i < len; i++) {
            this.onDeleteTab(selectedTabIds[i]);
        }
        this.setState({selectedTabIds: []});
    }

    onDeleteTab(tabId) {
        const {tabList} = this.state;
        for (let i = 0, len = tabList.length; i < len; i++) {
            if (tabList[i].tabId == tabId) {
                tabList.splice(i, 1);
                break;
            }
        }
        this.setState({tabList: tabList});
    }

    onEditTab(tabId) {
        let tabData = {};
        const {tabList} = this.state;
        for (let i = 0, len = tabList.length; i < len; i++) {
            if (tabList[i].tabId == tabId) {
                tabData = tabList[i].data;
                break;
            }
        }

        this.setState({
            tabData: tabData,
            dsVisible: true
        });
    }
    
    onOk(values) {
        let tabList = this.state.tabList;

        let tabCount = this.state.tabCount;

        let id = values.id;
        // 根据id是否存在判断是新增还是编辑
        if (!!id) { // 编辑保存
            for (let i = 0, len = tabList.length; i < len; i++) {
                if (tabList[i].tabId == id) {
                    tabList[i].tabTitle = WeaInputLocale.getCurrentLabel(values.title);
                    tabList[i].data = values;
                }
            }
        } else { // 新建保存
            id = String(++tabCount);
            values.id = id;
            tabList.push({
                key: id,
                tabId: id,
                tabTitle: WeaInputLocale.getCurrentLabel(values.title),
                data: values
            });
        }

        this.setState({
            tabCount: tabCount,
            tabList: tabList,
            dsVisible: false
        });
    }

    onCancel() {
        this.setState({
            dsVisible: false
        });
    }

    onSortTab(tabList) {
        this.setState({
            tabList: tabList
        });
    }

    getSaveValues() {
        return {
            tabIds: this.state.tabIds,
            tabList: this.state.tabList
        };
    }
}

export default DataSourceTable;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/DataSourceTable.js